import { render, staticRenderFns } from "./PopupBlock.vue?vue&type=template&id=39e622b2&"
import script from "./PopupBlock.vue?vue&type=script&lang=js&"
export * from "./PopupBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports